'use client'

import { markCarriedFbclid } from '@shared/marketing/click-provenance'

import { buildHomeUrl } from '../builders/home-url'

type NavigateOptions = {
  to?: 'home' | 'ai'
  preserveParams?: boolean
}

export const useNavigateToHome = () => {
  return (options: NavigateOptions = {}) => {
    const target = buildHomeUrl({ to: options.to })

    try {
      if (typeof window === 'undefined') {
        return
      }

      let finalUrl = target
      if (options.preserveParams) {
        const urlObj = new URL(target, window.location.origin)
        const currentParams = new URLSearchParams(window.location.search)
        currentParams.forEach((value, key) => {
          if (!urlObj.searchParams.has(key)) {
            urlObj.searchParams.set(key, value)
          }
        })
        markCarriedFbclid(urlObj)
        finalUrl = urlObj.pathname + urlObj.search
      }

      if (typeof window.location.assign === 'function') {
        window.location.assign(finalUrl)
      } else {
        window.location.href = finalUrl
      }
    } catch {
      if (typeof window !== 'undefined') {
        window.location.href = target
      }
    }
  }
}
